import moment from "moment";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
  Typography,
} from "@mui/material";
import { moneyFormat } from "../../../../../utils/Masks/Masks";
import { Button } from "@mui/material";
import TicketService from "services/ticket";
import ClienteService from "services/cliente";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import ModalRedirect from "components/DataDisplay/ModalRedirect/ModalRedirect";

export default function NoteData({ ticket, onClickInvoice, onClickTicket }) {
  const [showModalRedirect, setShowModalRedirect] = useState(false);
  const router = useHistory();
  const { segmento } = ClienteService.localEntrega;

  const isBlocked = ticket["bloqueia-emissao"];

  const ticketStatus = TicketService.getTicketStatus(ticket);

  const bgColor =
    ticketStatus === "avencer" || ticketStatus === "open"
      ? "#FF9703"
      : ticketStatus === "paid"
      ? "#00A326"
      : ticketStatus === "outdated"
      ? "#EA4C4B"
      : "#A2A2A2";

  return (
    <>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        mb={"24px"}
      >
        <Typography fontSize={"36px"} fontWeight={800} color={"#03A9F5"}>
          {"Dados da nota"}
        </Typography>
        <Stack
          borderRadius={"32px"}
          minWidth={"73px"}
          bgcolor={bgColor}
          textAlign={"center"}
          padding={"16px"}
        >
          <Typography fontSize="11px" fontWeight={600} color="#FFFFFF">
            Nota fiscal{" "}
            {ticketStatus === "avencer" || ticketStatus === "open" ? (
              "a vencer"
            ) : ticketStatus === "paid" ? (
              "paga"
            ) : ticketStatus === "outdated" ? (
              "vencida"
            ) : (
              <>
                cancelada/
                <br />
                devolvida
              </>
            )}
          </Typography>
        </Stack>
      </Stack>
      <Stack gap={"8px"}>
        <Typography fontSize={"14px"} fontWeight={500} color={"#636363"}>
          {segmento === "INDUSTRIAL" ? "Local de entrega" : "Endereço"}
        </Typography>
        <Typography fontSize={"24px"} fontWeight={700} color={"#053462"}>
          {ticket["endereco"] ?? "Não informado"}
        </Typography>
      </Stack>
      <Stack direction={"row"} gap={"24px"} mt={"24px"}>
        <Stack gap={"8px"}>
          <Typography fontSize={"14px"} fontWeight={500} color={"#636363"}>
            {"Número da nota fiscal"}
          </Typography>
          <Typography fontSize={"24px"} fontWeight={700} color={"#053462"}>
            {ticket["nr-nota-fis"]}
          </Typography>
        </Stack>

        <Stack gap={"8px"}>
          <Typography fontSize={"14px"} fontWeight={500} color={"#636363"}>
            Série da nota fiscal
          </Typography>
          <Typography fontSize={"24px"} fontWeight={700} color={"#053462"}>
            {ticket["serie"]}
          </Typography>
        </Stack>

        <Stack gap={"8px"}>
          <Typography fontSize={"14px"} fontWeight={500} color={"#636363"}>
            Data de emissão
          </Typography>
          <Typography fontSize={"24px"} fontWeight={700} color={"#053462"}>
            {moment(ticket["dt-emis-nota"], "YYYY-MM-DD").format("DD/MM/YYYY")}
          </Typography>
        </Stack>
        <Stack gap={"8px"}>
          <Typography fontSize={"14px"} fontWeight={500} color={"#636363"}>
            Número de romaneio
          </Typography>
          <Typography fontSize={"24px"} fontWeight={700} color={"#053462"}>
            {ticket["nr-romaneio"]}
          </Typography>
        </Stack>
      </Stack>

      <Stack
        border={"2px solid #05346299"}
        borderRadius={"8px"}
        mt={"32px"}
        p={"16px"}
      >
        <TableContainer
          sx={{
            borderRadius: "8px ",
            overflow: "hidden",
            minHeight: "200px",
          }}
        >
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  "& th": {
                    color: "#053462",
                    fontSize: "14px",
                    fontWeight: 500,
                    backgroundColor: "#E0E0E0",
                  },
                }}
              >
                <TableCell sx={{ borderBottomLeftRadius: "8px" }}>
                  Item
                </TableCell>
                <TableCell>Valor unitário</TableCell>
                <TableCell
                  sx={{
                    borderBottomRightRadius: "8px",
                  }}
                  align={"right"}
                >
                  Quantidade consumida
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {ticket.Itens.map((item, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "& td": {
                      fontSize: "16px",
                      fontWeight: 700,
                      color: "#053462",
                      borderBottom: "none",
                    },
                  }}
                >
                  <TableCell>{item["desc-item"]}</TableCell>
                  <TableCell>
                    {item["vl-preuni"]}/{item["un"]}
                  </TableCell>
                  <TableCell align="right">
                    {item["qt-faturada"]} {item["un"]}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Stack
          width={"auto"}
          direction={"row"}
          justifyContent={"flex-end"}
          bgcolor={"#63636333"}
          gap={0.7}
          p={"16px 24px"}
          borderRadius={"8px"}
        >
          <Typography fontSize="16px" fontWeight={600} color="#636363">
            Valor total da {"nota"}:
          </Typography>
          <Typography fontSize="24px" fontWeight={600} color="#053462">
            {moneyFormat(ticket["vl-tot-nota"])}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        direction={"row"}
        gap={2}
        width={"100%"}
        mt={"32px"}
        justifyContent={
          ticketStatus !== "avencer" || ticketStatus !== "outdated"
            ? "flex-end"
            : ""
        }
      >
        {segmento !== "INDUSTRIAL" && segmento !== "LICITACAO" && (
          <Button
            variant="outlined"
            color="secondary"
            fullWidth
            sx={{
              height: "55px",
              width: "100%",
              color: "#053462",
              borderColor: "#053462",
            }}
            onClick={() =>
              router.push({
                pathname: "/contestation",
                state: { invoiceData: ticket },
              })
            }
          >
            Dúvidas de consumo
          </Button>
        )}
        {(ticketStatus === "avencer" ||
          ticketStatus === "open" ||
          ticketStatus === "outdated") && (
          <>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              sx={{
                width: "100%",
                height: "55px",
                color: "#fff",
              }}
              onClick={() => {
                if (isBlocked) {
                  setShowModalRedirect(true);
                } else {
                  onClickInvoice();
                }
              }}
            >
              Acessar boleto
            </Button>
          </>
        )}

        <Button
          variant="contained"
          color="secondary"
          sx={{
            height: "55px",
            color: "#fff",
            width:
              ticketStatus === "avencer" ||
              ticketStatus === "outdated" ||
              segmento !== "INDUSTRIAL"
                ? "100%"
                : "35%",
          }}
          onClick={onClickTicket}
        >
          Acessar nota fiscal
        </Button>

        <ModalRedirect
          open={showModalRedirect}
          onClose={() => setShowModalRedirect(false)}
        />
      </Stack>
    </>
  );
}
